import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Colors from "../../../styles/Colors";
import Button from "../../../components/Button";
import { H4 } from "../../../styles/Fonts";
import {
  getAccountETHBalance,
  wrapETHtoWETH,
} from "../../../utils/api/lendingPoolApi";
import CustomModal from "../../../components/Modal";
import { getTruncNum } from "../../../utils/common";
import { useWeb3React } from "@web3-react/core";
import AmountInput from "../../../components/AmountInput";

const WrapEthModal: React.FC<{
  isShowModal: boolean;
  setShowModal: (v: boolean) => void;
  setIsWrapping: (v: boolean) => void;
  tokenBalance: number;
  updateTokenBalance: () => void;
}> = (props) => {
  const {
    isShowModal,
    setShowModal,
    setIsWrapping,
    tokenBalance,
    updateTokenBalance,
  } = props;

  const [ethAmount, setEthAmount] = useState<number>(0);
  const [ethBalance, setEthBalance] = useState<number>(0);

  const { account, chainId, library } = useWeb3React();

  const getAccountBalance = async (_address: string) => {
    if (!chainId) {
      return;
    }
    const _ethBalance = await getAccountETHBalance(_address, chainId, library);
    setEthBalance(_ethBalance);
  };

  useEffect(() => {
    if (account && chainId) {
      getAccountBalance(account);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [account, chainId]);

  const handleWrapEth = async (address: string, amount: number) => {
    if (account && chainId && library) {
      setShowModal(false);
      setIsWrapping(true);

      try {
        await wrapETHtoWETH(address, amount, chainId, library);
        getAccountBalance(address);
        updateTokenBalance();
      } catch (e) {
        console.log(e);
      }

      setIsWrapping(false);
      setEthAmount(0);
    }
  };

  return (
    <CustomModal
      show={isShowModal}
      onHide={() => setShowModal(false)}
      title="Wrap Your ETH to WETH"
    >
      <AmountInput
        setAmount={setEthAmount}
        tokenSymbol={"ETH"}
        tokenDecimal={18}
        showMaxBtn={false}
      />
      <InfoContainer>
        <BalanceRow>
          <Label>Wallet Balance</Label>
        </BalanceRow>
        <BalanceRow>
          <Label>ETH</Label>
          <Value>{`${getTruncNum(+ethBalance, 18)} ETH`}</Value>
        </BalanceRow>
        <BalanceRow>
          <Label>WETH</Label>
          <Value>{`${getTruncNum(+tokenBalance, 18)} WETH`}</Value>
        </BalanceRow>
      </InfoContainer>
      <BtnContainer>
        <Button
          btnType="primary"
          btnText={"Wrap"}
          onClick={() => (account ? handleWrapEth(account, ethAmount) : null)}
          disabled={!ethAmount}
          isLoading={false}
        />
      </BtnContainer>
    </CustomModal>
  );
};

export default WrapEthModal;

const InfoContainer = styled.div`
  margin-top: 20px;
`;

const Label = styled(H4)`
  color: ${Colors.gray3};
  font-size: 13px;
  line-height: 22px;
`;

const Value = styled.span`
  margin: 0;
  font-size: 14px;
  line-height: 22px;
  font-weight: bold;
  color: ${Colors.ivory};
  text-align: right;
  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 20px;
  }
`;

const BalanceRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 12px;
`;

const BtnContainer = styled.div`
  margin-top: 20px;
  button {
    border-radius: 4px;
    font-size: 16px;
    line-height: 22px;
  }
`;
